import InfoIcon from '@Assets/Images/info-icon.svg';
import { Alert } from '@Types/Alert.types';
import { ALERT_TYPES, PATHS } from '@Utils/constants';
import { Icons, SectionCard } from '@kg-internal/pv3-uikit';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import './NotificationAlert.scss';

type Props = {
  onDismiss: (id: string) => void;
  alert: Alert;
  onClick: (id: string) => void;
};
const ICONS: { info: ReactNode; warning: ReactNode; error: ReactNode } = {
  warning: Icons.WarningNotifOrange,
  error: Icons.WarningNotifRed,
  info: <img src={InfoIcon} alt='info' />,
};
const block = 'notification-alert';

const NotificationAlert = ({ onDismiss, alert, onClick }: Props) => {
  const type: string = Object.values(ALERT_TYPES).find((element) => element.type === alert.type)?.severity || 'info';
  const notificationIcon: ReactNode = ICONS[type as keyof typeof ICONS];
  const urlLabel = "View Asset";
  const url = `${PATHS.ASSETS}/${alert.asset}`;

  return (
    <SectionCard className={`${block}__card ${block}__card--${type}`}>
      <div className={`${block}__icon notification-alert__icon`}>{notificationIcon}</div>
      <p>
        {alert.message}{' '}
        <Link to={url} className={`${block}__url`} onClick={() => onClick(alert.id)}>
          {urlLabel}
        </Link>
      </p>
      <button type='button' className={`${block}__close`} onClick={() => onDismiss(alert.id)}>
        {Icons.Exit}
      </button>
    </SectionCard>
  );
};

export default NotificationAlert;
